import { useContext } from 'react';
import { Modal } from 'react-bootstrap';
import { ModalContext } from '../../GlobalContex';

export const ModalWindow = () => {
  const {modal, setModal} = useContext(ModalContext);

  return (
    <Modal
      show={modal.open}
      onHide={() => setModal({open: false})}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Modal.Header className='bg-warning' closeButton>
        <Modal.Title id="contained-modal-title-vcenter">{modal.title}</Modal.Title>
      </Modal.Header>
      {modal.body && <Modal.Body><div dangerouslySetInnerHTML={{__html: modal.body}} /></Modal.Body>}
      {modal.footer && <Modal.Footer>{modal.footer}</Modal.Footer>}
    </Modal>
  );
};
